import {ShapeCommand} from '../../commands.template';

export class FlowlineReorderInteractionCommand extends ShapeCommand {
  services: any;
  reverseData: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();

    this.reverseData = {
      flowlineMxKey: this.object.flowlineMxKey,
      index: this.object.oldIndex
    };

    const action = {
      changeInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        index: this.object.index
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.services.graphHelperSvc.redrawInteractions(
      this.services.jsonHandlerSvc.get().interactions
    );
  }

  public reverse() {
    super.reverse();
    const action = {
      changeInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        index: this.reverseData.index
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.services.graphHelperSvc.redrawInteractions(
      this.services.jsonHandlerSvc.get().interactions
    );
  }
}
